import React, { useState, useEffect } from 'react';
import {
  getContasFixas, createContaFixa, updateContaFixa, deleteContaFixa,
  pagarContaFixa, getCategoriasGasto,
} from '../api';

const fmt = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const GRUPOS_LABEL = {
  fixa: 'Despesa fixa', mao_obra: 'Mão de obra', insumo: 'Insumo',
  variavel_custo: 'Variável (custo)', variavel_venda: 'Variável (venda)', investimento: 'Investimento',
};
const STATUS_COLOR = { pago: 'var(--g)', pendente: 'var(--c4)', atrasado: 'var(--r)', vencendo: 'var(--y)' };
const STATUS_LABEL = { pago: '✓ Pago', pendente: 'Pendente', atrasado: '⚠ Atrasado', vencendo: '⏰ Vencendo' };

function PagarModal({ conta, onConfirm, onCancel, saving }) {
  const [valor, setValor] = useState(String(Number(conta.valor_efetivo || conta.valor_previsto).toFixed(2)));
  const [data, setData] = useState(new Date().toISOString().split('T')[0]);
  const [forma, setForma] = useState('pix');

  return (
    <div className="ov" onClick={onCancel}>
      <div className="mo" onClick={e => e.stopPropagation()} style={{ maxWidth: 360 }}>
        <div className="mo-handle" />
        <h3>💳 Pagar: {conta.nome}</h3>
        <div className="mo-sub">Valor previsto: {fmt(conta.valor_efetivo)}</div>
        <form className="fm" onSubmit={e => { e.preventDefault(); onConfirm({ valor: Number(valor), data, forma_pagamento: forma }); }}>
          <div>
            <label style={{ fontSize: 12, color: 'var(--c4)', display: 'block', marginBottom: 4 }}>Valor pago (R$)</label>
            <input className="inp" type="number" step="0.01" min="0.01" value={valor} onChange={e => setValor(e.target.value)} required autoFocus />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--c4)', display: 'block', marginBottom: 4 }}>Data do pagamento</label>
            <input className="inp" type="date" value={data} onChange={e => setData(e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--c4)', display: 'block', marginBottom: 4 }}>Forma de pagamento</label>
            <select className="inp inp-sel" value={forma} onChange={e => setForma(e.target.value)}>
              <option value="pix">PIX</option>
              <option value="dinheiro">Dinheiro</option>
              <option value="cartao">Cartão</option>
              <option value="boleto">Boleto</option>
            </select>
          </div>
          <div className="btn-g">
            <button className="btn btn1" type="submit" disabled={saving}>
              {saving ? 'Registrando...' : 'Confirmar pagamento'}
            </button>
            <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ContaForm({ initialData, categorias, onSubmit, onCancel, saving }) {
  const [nome, setNome] = useState(initialData?.nome || '');
  const [categoriaId, setCategoriaId] = useState(initialData?.categoria_id ? String(initialData.categoria_id) : '');
  const [valor, setValor] = useState(initialData?.valor_previsto ? String(Number(initialData.valor_previsto).toFixed(2)) : '');
  const [dia, setDia] = useState(initialData?.dia_vencimento ? String(initialData.dia_vencimento) : '');
  const [pct, setPct] = useState(initialData?.percentual_negocio ? String(initialData.percentual_negocio) : '100');

  const catsFiltradas = categorias.filter(c => ['fixa', 'mao_obra'].includes(c.grupo));
  const valorEfetivo = Number(valor) * Number(pct) / 100;

  return (
    <form className="fm" onSubmit={e => {
      e.preventDefault();
      onSubmit({ nome, categoria_id: Number(categoriaId), valor_previsto: Number(valor), dia_vencimento: dia ? Number(dia) : null, percentual_negocio: Number(pct) });
    }}>
      <input className="inp" placeholder="Nome da conta (ex: Aluguel da cozinha) *" value={nome} onChange={e => setNome(e.target.value)} required autoFocus />
      <select className="inp inp-sel" value={categoriaId} onChange={e => setCategoriaId(e.target.value)} required>
        <option value="">Categoria *</option>
        {catsFiltradas.map(c => (
          <option key={c.id} value={c.id}>{c.icone} {c.nome} ({GRUPOS_LABEL[c.grupo]})</option>
        ))}
      </select>
      <div className="inp-r">
        <div style={{ flex: 2 }}>
          <label style={{ fontSize: 12, color: 'var(--c4)', display: 'block', marginBottom: 4 }}>Valor mensal previsto (R$) *</label>
          <input className="inp" type="number" step="0.01" min="0" placeholder="Ex: 800" value={valor} onChange={e => setValor(e.target.value)} required />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 12, color: 'var(--c4)', display: 'block', marginBottom: 4 }}>Dia vencimento</label>
          <input className="inp" type="number" min="1" max="31" placeholder="Ex: 10" value={dia} onChange={e => setDia(e.target.value)} />
        </div>
      </div>
      <div>
        <label style={{ fontSize: 12, color: 'var(--c4)', display: 'block', marginBottom: 4 }}>
          % do negócio: {pct}% (conta usada parcialmente em casa?)
        </label>
        <input type="range" min="1" max="100" value={pct} onChange={e => setPct(e.target.value)} style={{ width: '100%' }} />
        {Number(pct) < 100 && (
          <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 4 }}>
            Valor usado na precificação: {fmt(valorEfetivo)}
          </div>
        )}
      </div>
      <div className="btn-g">
        <button className="btn btn1" type="submit" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
        <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
      </div>
    </form>
  );
}

export default function ContasFixasPage({ onToast }) {
  const [dados, setDados] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editConta, setEditConta] = useState(null);
  const [pagarConta, setPagarConta] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const [d, cats] = await Promise.all([getContasFixas(), getCategoriasGasto()]);
      setDados(d);
      setCategorias(cats.lista || []);
    } catch (err) { onToast(err.message, 'error'); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const doSave = async (fn, msg) => {
    setSaving(true);
    try { await fn(); onToast(msg); load(); }
    catch (err) { onToast(err.message, 'error'); }
    setSaving(false);
  };

  if (loading) return <div style={{ padding: 24, color: 'var(--c4)' }}>Carregando...</div>;

  const contas = dados?.contas || [];
  const totalPrevisto = dados?.totalPrevisto || 0;
  const totalPago = dados?.totalPago || 0;

  return (
    <div>
      {/* Sumário */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
        <div className="c" style={{ padding: '12px 14px' }}>
          <div style={{ fontSize: 11, color: 'var(--c4)', marginBottom: 4 }}>Total previsto / mês</div>
          <div style={{ fontSize: 20, fontWeight: 800 }}>{fmt(totalPrevisto)}</div>
        </div>
        <div className="c" style={{ padding: '12px 14px' }}>
          <div style={{ fontSize: 11, color: 'var(--c4)', marginBottom: 4 }}>Pago este mês</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: totalPago >= totalPrevisto * 0.9 ? 'var(--g)' : 'var(--r)' }}>
            {fmt(totalPago)}
          </div>
        </div>
      </div>

      {/* Custo por minuto */}
      {totalPrevisto > 0 && (
        <div style={{ padding: '10px 14px', background: 'var(--g4)', borderRadius: 10, fontSize: 12, color: 'var(--c4)', marginBottom: 16 }}>
          Com 100h/mês de produção · Despesas = <strong>R$ {(totalPrevisto / 6000).toFixed(4)}/min</strong> ·
          Em 30 min de preparo: <strong>{fmt(totalPrevisto / 6000 * 30)}</strong>
        </div>
      )}

      {/* Botão e lista */}
      <div className="c-h" style={{ marginBottom: 12 }}>
        <span className="c-t">Contas fixas mensais</span>
        <button className="btn btn1 btn-sm" onClick={() => { setShowForm(true); setEditConta(null); }}>+ Nova conta</button>
      </div>

      {showForm && (
        <div className="c" style={{ marginBottom: 12 }}>
          <ContaForm
            initialData={editConta}
            categorias={categorias}
            saving={saving}
            onSubmit={async data => {
              if (editConta) await doSave(() => updateContaFixa(editConta.id, data), 'Conta atualizada!');
              else await doSave(() => createContaFixa(data), 'Conta adicionada!');
              setShowForm(false); setEditConta(null);
            }}
            onCancel={() => { setShowForm(false); setEditConta(null); }}
          />
        </div>
      )}

      {contas.length === 0 ? (
        <div className="mt">
          <span className="mt-ico">🏠</span>
          Nenhuma conta fixa cadastrada. Adicione aluguel, energia, água e outros gastos mensais.
        </div>
      ) : (
        <div className="lst">
          {contas.map(c => (
            <div key={c.id} className="it" style={{ alignItems: 'flex-start' }}>
              <div className="it-main">
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <strong style={{ fontSize: 14 }}>{c.icone} {c.nome}</strong>
                  <span className="bd bd-r" style={{ fontSize: 10 }}>{GRUPOS_LABEL[c.grupo]}</span>
                  <span style={{ fontSize: 11, color: STATUS_COLOR[c.status], fontWeight: 600 }}>
                    {STATUS_LABEL[c.status]}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 2 }}>
                  {c.dia_vencimento && `Vence dia ${c.dia_vencimento} · `}
                  {c.percentual_negocio < 100 && `${c.percentual_negocio}% do negócio · `}
                  Previsto: {fmt(c.valor_efetivo)}
                  {c.pago_mes > 0 && ` · Pago: ${fmt(c.pago_mes)}`}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 4, flexShrink: 0, flexDirection: 'column', alignItems: 'flex-end' }}>
                <strong style={{ fontSize: 15 }}>{fmt(c.valor_efetivo)}</strong>
                <div style={{ display: 'flex', gap: 4 }}>
                  {c.status !== 'pago' && (
                    <button className="btn btn1 btn-sm" onClick={() => setPagarConta(c)}>💳 Pagar</button>
                  )}
                  <button className="btn btn3 btn-sm" onClick={() => { setEditConta(c); setShowForm(true); }}>✏️</button>
                  <button className="btn btn-sm" style={{ background: 'var(--r3)', color: 'var(--r)', border: '1px solid #fecaca' }}
                    onClick={() => doSave(() => deleteContaFixa(c.id), 'Conta removida')}>✕</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {pagarConta && (
        <PagarModal
          conta={pagarConta}
          saving={saving}
          onConfirm={async data => {
            await doSave(() => pagarContaFixa(pagarConta.id, data), `${pagarConta.nome} pago!`);
            setPagarConta(null);
          }}
          onCancel={() => setPagarConta(null)}
        />
      )}
    </div>
  );
}
